export default "__VITE_ASSET__B8sA1bY___"